'use client'
import { FC, useState, useEffect } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText, SliceZone } from "@prismicio/react";
import { components } from "@/slices";
import { createClient } from "@/prismicio";

/**
 * Props for `TabbedNumberPanels`.
 */
export type TabbedNumberPanelsProps =
  SliceComponentProps<Content.TabbedNumberPanelsSlice>;

/**
 * Component for "TabbedNumberPanels" Slices.
 */
const TabbedNumberPanels: FC<TabbedNumberPanelsProps> = ({ slice }) => {
  
  const [tabOpen, setTabOpen] = useState("1");

  const [campaignSlices, setCampaignSlices] = useState([]) as any

  useEffect(()=> {

    const getCampaign = async (slice: any)=>{
      const client = createClient()
      const uidSet=[] as any

      {tabOpen === "1" ?
      slice.primary.tab_one_global_block.uid ? uidSet.push(slice.primary.tab_one_global_block.uid) : null
      :<></>}
      {tabOpen === "2" ?
        slice.primary.tab_two_global_block.uid ? uidSet.push(slice.primary.tab_two_global_block.uid) : null
      :<></>}
      {tabOpen === "3" ?
        slice.primary.tab_three_global_block.uid ? uidSet.push(slice.primary.tab_three_global_block.uid) : null
      :<></>}

      const response = await client.getByUIDs("campaign", uidSet) as any

      setCampaignSlices(response.results)
    }
  
    getCampaign(slice) as any

  }, [tabOpen, slice])

  // console.log(campaignSlices)
  const colSpans = slice.primary.tab_three_name && slice.primary.tab_two_name ? "col-span-12 md:col-span-4" : !slice.primary.tab_three_name && slice.primary.tab_two_name ? "col-span-12 md:col-span-6" : "col-span-12"

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className="mt-28  xl:px-0 font-fellix"
    >
      <div className="max-w-[800px] mx-auto text-center prose-p:text-[28px] prose-p:leading-[28px] prose-p:m-0 prose-p:mt-8 mb-18">
        <PrismicRichText field={slice.primary.heading} />
        <PrismicRichText field={slice.primary.description} />
      </div>
      <div className="grid grid-cols-12 gap-0 max-w-[1280px] mx-auto">
        {slice.primary.tab_one_name ?
        <button type="button" className={`${tabOpen === "1" ? "bg-orangetint" : "bg-white"} ${colSpans} hover:bg-orange duration-300 hover:!text-white cursor-pointer`} onClick={()=>setTabOpen("1")}>
          <p className="text-[28px] leading-[36px] text-center font-semibold py-6">{slice.primary.tab_one_name}</p>
        </button>
        :<></>}
        {slice.primary.tab_two_name ?
        <button type="button" className={`${tabOpen === "2" ? "bg-orangetint" : "bg-white"} ${colSpans} hover:bg-orange duration-300 hover:!text-white cursor-pointer`} onClick={()=>setTabOpen("2")}>
          <p className="text-[28px] leading-[36px] text-center font-semibold py-6">{slice.primary.tab_two_name}</p>
        </button>
        :<></>}
        {slice.primary.tab_three_name ?
        <button type="button" className={`${tabOpen === "3" ? "bg-orangetint" : "bg-white"} ${colSpans} hover:bg-orange duration-300 hover:!text-white cursor-pointer`} onClick={()=>setTabOpen("3")}>
          <p className="text-[28px] leading-[36px] text-center font-semibold py-6">{slice.primary.tab_three_name}</p>
        </button>
        :<></>}
      </div>

          <div className="bg-orangetint px-4 md:px-8 2xl:px-0 mb-16">
            <div className="inner-wrapper">
              <div className="text-center py-16 max-w-[700px] mx-auto text-[20px] leading-[28px] md:text-[28px] md:leading-[36px]">
                {tabOpen === "1" ?
                <PrismicRichText field={slice.primary.tab_one_intro} />
                :<></>}
                {tabOpen === "2" ?
                  <PrismicRichText field={slice.primary.tab_two_intro} />
                :<></>}
                {tabOpen === "3" ?
                  <PrismicRichText field={slice.primary.tab_three_intro} />
                :<></>}
              </div>
              <div className="grid grid-cols-12 mx-auto max-w-[1280px] gap-0 md:gap-x-8">
                {slice.primary.content.map((item: any, index: number)=>{
                  if(item.tab_number === tabOpen) {
                      return (
                          <div className="col-span-12 md:col-span-4 xl:col-span-4" key={index} style={{paddingBottom: 100}}>
                            <div className="border-t-[4px] border-t-orange"></div>
                            <h2 className="!text-[100px] !font-normal !leading-[100px] text-orange mt-[20px]">{item.number}</h2>
                            <p className="text-[20px] leading-[28px] md:text-[28px] md:leading-[36px] font-semibold text-jade my-4">{item.title}</p>
                            <article className="max-w-[70%] text-[14px]">
                              <PrismicRichText field={item.description} />
                            </article>
                          </div>
                      )
                    }
                    return null;
                  })}
              </div>
              <div className="fineprint">
                {/* <PrismicRichText field={slice.primary.fineprint}/> */}
              </div>
          </div>
        </div>
        {campaignSlices?.length ? 
        <div className="my-16 mx-auto max-w-[1440px]">
          <SliceZone slices={campaignSlices[0]?.data.slices} components={components}/>
        </div>
        : <></>}
    </section>
  );
};

export default TabbedNumberPanels;
